<template>
  <div class="convite-card">
    <!-- Mosaico de fotos -->
    <div v-if="photos.length > 0" :class="['convite-mosaic', 'convite-mosaic--' + photos.length]">
      <div
        v-for="(photo, i) in photos"
        :key="i"
        :class="['convite-mosaic__cell', 'convite-mosaic__cell--' + i]"
      >
        <img :src="photo" :alt="'Foto ' + (i + 1)" />
      </div>
    </div>

    <!-- Conteúdo textual -->
    <div class="convite-card__body">
      <h2 class="convite-card__title">{{ eventName }}</h2>

      <div v-if="formattedDateTime || location || dressCode" class="convite-card__details">
        <p v-if="formattedDateTime" class="convite-card__detail convite-card__detail--date">
          <i class="fas fa-calendar-alt"></i>
          {{ formattedDateTime }}
        </p>
        <p v-if="location" class="convite-card__detail">
          <i class="fas fa-map-marker-alt"></i>
          {{ location }}
        </p>
        <p v-if="dressCode" class="convite-card__detail">
          <i class="fas fa-tshirt"></i>
          {{ dressCode }}
        </p>
      </div>

      <slot name="cta" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConviteCard',

  props: {
    eventName: { type: String, default: '' },
    photos: { type: Array, default: () => [] }, // array de URLs ou dataURLs
    eventDate: { type: String, default: '' },   // "YYYY-MM-DD"
    eventTime: { type: String, default: '' },   // "HH:mm"
    location: { type: String, default: '' },
    dressCode: { type: String, default: '' },
  },

  computed: {
    formattedDateTime() {
      if (!this.eventDate) return '';
      const [year, month, day] = this.eventDate.split('-');
      const months = ['janeiro','fevereiro','março','abril','maio','junho','julho',
                      'agosto','setembro','outubro','novembro','dezembro'];
      let str = `${parseInt(day)} de ${months[parseInt(month) - 1]} de ${year}`;
      if (this.eventTime) {
        const [h, m] = this.eventTime.split(':');
        str += ` · ${h}h${m && m !== '00' ? m : ''}`;
      }
      return str;
    },
  },
};
</script>

<style scoped>
.convite-card {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.10);
  font-family: inherit;
}

/* ── Mosaico ─────────────────────────────────────── */
.convite-mosaic {
  width: 100%;
  display: grid;
  gap: 3px;
  background: #e0e0e0;
}

/* 1 foto: 16:9 */
.convite-mosaic--1 { grid-template-columns: 1fr; }
.convite-mosaic--1 .convite-mosaic__cell { aspect-ratio: 16 / 9; }

/* 2 fotos: lado a lado */
.convite-mosaic--2 { grid-template-columns: 1fr 1fr; }
.convite-mosaic--2 .convite-mosaic__cell { aspect-ratio: 4 / 3; }

/* 3 fotos: 1 full width + 2 embaixo */
.convite-mosaic--3 { grid-template-columns: 1fr 1fr; }
.convite-mosaic--3 .convite-mosaic__cell--0 { grid-column: 1 / 3; aspect-ratio: 16 / 9; }
.convite-mosaic--3 .convite-mosaic__cell--1,
.convite-mosaic--3 .convite-mosaic__cell--2 { aspect-ratio: 4 / 3; }

/* 4 fotos: 2x2 */
.convite-mosaic--4 { grid-template-columns: 1fr 1fr; }
.convite-mosaic--4 .convite-mosaic__cell { aspect-ratio: 4 / 3; }

/* 5 fotos: 1 grande esquerda (2 linhas) + 4 direita */
.convite-mosaic--5 { grid-template-columns: 1fr 1fr; }
.convite-mosaic--5 .convite-mosaic__cell--0 { grid-row: 1 / 3; }
.convite-mosaic--5 .convite-mosaic__cell--1,
.convite-mosaic--5 .convite-mosaic__cell--2,
.convite-mosaic--5 .convite-mosaic__cell--3,
.convite-mosaic--5 .convite-mosaic__cell--4 { aspect-ratio: 4 / 3; }

.convite-mosaic__cell {
  overflow: hidden;
  background: #f0f0f0;
}
.convite-mosaic__cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ── Corpo ───────────────────────────────────────── */
.convite-card__body {
  padding: 1.25rem 1.5rem 1.5rem;
}

.convite-card__title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 0.75rem;
}

.convite-card__details {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.convite-card__detail {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #444;
  margin: 0;
  line-height: 1.4;
}

.convite-card__detail i {
  color: #ff50a3;
  width: 14px;
  flex-shrink: 0;
  margin-top: 2px;
}

.convite-card__detail--date {
  font-weight: 600;
  color: #ff50a3;
}
.convite-card__detail--date i {
  color: #ff50a3;
}
</style>
